import { aiMentionDepartmentApi } from '../../api/aiAssistant';
import { useCompany } from '../../hooks/company';
import MentionTag, { MentionInfoRow } from './MentionTag';
import { canUseAiDepartment } from './scope';

interface Props {
  name: string;
  departmentId: string;
}

/**
 * 消息里的部门提及：渲染成部门标签，hover 弹出部门信息卡。
 * 部门功能面向管理层，数据范围为「仅本人」的用户回查恒为空 → 展示「无权查看」。
 */
const MentionDepartment = ({ name, departmentId }: Props) => {
  const { id: companyId, currentUser, hasPermission } = useCompany();
  const allowed = canUseAiDepartment({
    isSuperAdmin: currentUser?.isSuperAdmin,
    departmentId: currentUser?.departmentId,
    hasPermission,
  });

  const load = async (): Promise<MentionInfoRow[] | null> => {
    // 降权后再看历史消息里的部门提及：回查会被后端 403，直接跳过请求给出无权提示，
    // 否则 hover 出来的是「加载失败，请重试」，看着像故障
    if (!allowed) {
      return null;
    }
    const list = await aiMentionDepartmentApi.lookup(companyId, [departmentId]);
    const info = list.find((d) => String(d.departmentId) === departmentId);
    if (!info) {
      return null;
    }
    return [
      ['部门', info.name],
      ['上级部门', info.parentName || '—'],
      ['在职成员', info.memberCount == null ? '—' : `${info.memberCount} 人`],
    ];
  };

  return (
    <MentionTag
      label={name}
      color="#389e0d"
      background="rgba(82, 196, 26, 0.12)"
      cacheKey={`department:${companyId}:${departmentId}`}
      load={load}
      missingText="无权查看该部门信息或部门不存在"
    />
  );
};

export default MentionDepartment;
